import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format } from 'date-fns';
import { useChatArtifactStore } from '../../lib/stores/ChatArtifactStore';
/**
 * DocumentVersionList Component
 * Displays all versions of a document in a scrollable list
 * Shows creation date and allows selecting different versions
 */ export const DocumentVersionList = ({ artifactId, onVersionSelect })=>{
    const { getVersions, previewVersion } = useChatArtifactStore((state)=>({
            getVersions: state.getVersions,
            previewVersion: state.previewVersion
        }));
    const versions = getVersions(artifactId);
    if (!versions || versions.length === 0) {
        return /*#__PURE__*/ _jsx("div", {
            className: "text-sm text-muted-foreground py-4 px-3 text-center",
            children: "No version history available"
        });
    }
    const handleVersionClick = (version)=>{
        // Preview the version without modifying the main artifact
        // This allows temporary viewing of history without polluting the store
        previewVersion(artifactId, {
            content: version.content,
            title: version.title,
            updatedAt: version.updatedAt
        });
        // Call optional callback
        if (onVersionSelect) {
            // Pass the version if it's a ChatArtifact, otherwise just call with no args
            onVersionSelect('chatId' in version ? version : undefined);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "border-t",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "text-xs font-medium text-muted-foreground px-3 py-2",
                children: [
                    "Version History (",
                    versions.length,
                    ")"
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "divide-y max-h-80 overflow-y-auto",
                children: versions.map((version, index)=>{
                    const createdAt = new Date(version.createdAt || '');
                    const isLatest = index === 0;
                    return /*#__PURE__*/ _jsx("button", {
                        onClick: ()=>handleVersionClick(version),
                        className: "w-full text-left px-3 py-2 hover:bg-muted transition-colors text-xs",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-start justify-between gap-2",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex-1 min-w-0",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "font-medium text-foreground truncate",
                                            children: format(createdAt, 'MMM d, yyyy h:mm a')
                                        }),
                                        version.title && /*#__PURE__*/ _jsx("div", {
                                            className: "text-xs text-muted-foreground truncate mt-0.5",
                                            children: version.title
                                        })
                                    ]
                                }),
                                isLatest && /*#__PURE__*/ _jsx("span", {
                                    className: "inline-block px-2 py-0.5 rounded bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100 text-xs font-medium whitespace-nowrap",
                                    children: "Latest"
                                })
                            ]
                        })
                    }, `${version.id}-${version.updatedAt || index}`);
                })
            })
        ]
    });
};
